module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-14-LUGLIO-small-75653ed0f977cbacd0d90b0d5ab6dc05.jpg";